import _ from 'lodash';

import jsonApi from '@/services/api/json_api_service';
import serialize from '@/utils/devour/serializer';
import deserializer from '@/utils/devour/deserializer';

const defaultReadOnlyAttributes = ['updatedAt', 'createdAt', 'deletedAt'];

const jsonApiType = (name) => {
  return `${_.kebabCase(name)}s`;
};

const filterAttributes = (attributes, data, readOnlyAttributes = []) => {
  defaultReadOnlyAttributes.concat(readOnlyAttributes).forEach((readOnlyAttribute) => {
    if (_.has(attributes, readOnlyAttribute)) {
      delete attributes[readOnlyAttribute];
    }
  });
  const keys = Object.keys(attributes);
  keys.push('id');
  return _.pick(data, keys);
};

const filterRelationships = (relationships, data) => {
  const keys = Object.keys(relationships);
  const validRelationships = _.pick(data, keys);

  return _.mapValues(validRelationships, (value, key) => {
    if (_.isObject(value)) {
      return value;
    }
    return { id: value, type: jsonApiType(key) };
  });
};

const formatFilter = (filters) => {
  if (!filters) {
    return {};
  }
  return _.mapValues(filters, (filterValue) => {
    if (_.isArray(filterValue) && !_.isEmpty(filterValue)) {
      return filterValue.join(',');
    } else {
      return filterValue;
    }
  });
};

export const filterRelationshipsForUpdate = (relationships, data) => {
  _.forOwn(data, (value, key) => {
    if (_.has(relationships, key) && !relationships[key].update) {
      delete data[key];
    }
  });
};

export default (modelName, attributes, relationships, readOnlyAttributes = []) => {
  jsonApi.define(
    modelName,
    {
      ...attributes,
      ...relationships,
    },
    {
      serializer(item) {
        const attrs = filterAttributes(attributes, item, readOnlyAttributes);
        const rels = filterRelationships(relationships, item);
        const newItem = { ...attrs, ...rels };
        return serialize(jsonApi, modelName, newItem);
      },
      deserializer(item, included) {
        return deserializer.resource(jsonApi, item, included);
      },
    },
  );

  const model = jsonApi.modelFor(modelName);
  model.formatters = {};

  return {
    model,
    index(options) {
      jsonApi.auth();
      if (options) {
        options.filter = formatFilter(options.filter);
      }
      return jsonApi.findAll(modelName, options);
    },
    get(id, options) {
      jsonApi.auth();
      return jsonApi.find(modelName, id, options);
    },
    update(data) {
      jsonApi.auth();
      filterRelationshipsForUpdate(relationships, data);
      return jsonApi.update(modelName, data);
    },
    create(data) {
      jsonApi.auth();
      return jsonApi.create(modelName, data);
    },
    destroy(data) {
      jsonApi.auth();
      return jsonApi.destroy(modelName, data.id);
    },
  };
};
